var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light-gray flex items-center justify-around",staticStyle:{"width":"55px","height":"55px"}},[_c('h6',[_vm._v("n/a")])])}]

export { render, staticRenderFns }